module.exports = __webpack_public_path__ + "img/batsu_blue.4ed12da5.png";